import { Loader2 } from 'lucide-react';

interface RouteLoadingProps {
  label?: string;
}

/** Inline route loading state. Use as `<Suspense fallback={<RouteLoading />}>` in lazy routes. */
export default function RouteLoading({ label = 'Loading…' }: RouteLoadingProps) {
  return (
    <div className="flex min-h-[40vh] items-center justify-center text-[var(--ce-color-text-subtle)]">
      <div className="inline-flex items-center gap-2.5 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" />
        {label}
      </div>
    </div>
  );
}
